import Parallax from 'parallax-js';

function initParallax() {
	const scene = document.querySelector('.wp-block-emagine-parallax-cta .scene');
	if (scene) {
		const parallaxInstance = new Parallax(scene);
		parallaxInstance.friction(0.2, 0.2);
	}
}

document.addEventListener('DOMContentLoaded', initParallax);
